import { styled } from '@mui/system'
import { colors } from '../../../../../Components/consts'

export const TixActionCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row-reverse',
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
  '& .suiteBtn': {
    margin: theme.spacing(0, 1),
    borderRadius: 8,
    border: 'none',
    color: colors.black,
    fontSize: '1.2rem',
    padding: theme.spacing(1, 2),
    background: '#D7D7D7',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7rem',
      marginTop: theme.spacing(1),
      background: 'none',
      textDecoration: 'underline',
      padding: 0,
      color: colors.text,
    },
    '&:focus': {
      outline: 'none',
    },
  },
}))
